import { sanitizeObject } from "../helpers/sanitizers";

export default (data) => {
    return data.map(item => sanitizeObject(item));
};
